import { ADD_CATEGORY, EDIT_SUBCATEGORY } from './ApiConstants';
import api from './ApiHandler';

export const getSubCategoriesByPage = async (payload: any) => {
  return await api.get('/get-subcategories-list/store', { params: payload });
};

export const createSubCategory = async (payload: any) => {
  return await api.post(ADD_CATEGORY, { ...payload });
};

export const editSubCategory = async (payload: any) => {
  return await api.post(EDIT_SUBCATEGORY, { ...payload });
};
